// extracted by mini-css-extract-plugin
export default {"customLoadingFrame":"CustomLoadingAction_customLoadingFrame__TCtaR"};